<template>
  <router-view />
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* 全局样式：清除默认边距，适配三端 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
</style>
